"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateEmail = exports.htmlDecode = void 0;
/* eslint-disable import/prefer-default-export */

var parser = new window.DOMParser();
/**
* check for input string containing html code
*
* @param  {string} input
*         input string
*/

var htmlDecode = exports.htmlDecode = function htmlDecode(input) {
  var doc = parser.parseFromString(input, 'text/html');
  return doc.documentElement.textContent;
};

// simple (ish) email format validation
// we'll let the browser do the legwork if possible
var validateEmail = exports.validateEmail = function validateEmail(value) {
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var input = document.createElement('input');
  input.type = 'email';
  input.required = req;
  input.value = value;
  return typeof input.checkValidity === 'function' ? input.checkValidity() : /\S+@\S+\.\S+/.test(value);
};